import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IDetailsFilter } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IPage, IPageSize, ISort, TDefaultStoreNoSearchDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

type TInitialState =
	TDefaultStoreNoSearchDTO
	& Omit<IDetailsFilter<string | null>, 'parameterValueFirst' | 'parameterValueSecond'>

const initialState: TInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	paramName: null,
	siteId: null,
	gnbId: null,
	configId: null,
	delta: null,
};

const moBranch = createSlice({
	name: 'moBranch',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<ISort>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setParamName: (state, action: PayloadAction<{ paramName: string | null }>) => {
			state.paramName = action.payload.paramName;
			state.page = initialState.page;
		},
		setConfigId: (state, action: PayloadAction<{ configId: string | null }>) => {
			state.configId = action.payload.configId;
			state.page = initialState.page;
		},
		setSiteId: (state, action: PayloadAction<{ siteId: string | null }>) => {
			state.siteId = action.payload.siteId;
			state.page = initialState.page;
		},
		setNodeId: (state, action: PayloadAction<{ gnbId: string | null }>) => {
			state.gnbId = action.payload.gnbId;
			state.page = initialState.page;
		},
		setDelta: (state, action: PayloadAction<{ delta: string | null }>) => {
			state.delta = action.payload.delta;
			state.page = initialState.page;
		},
		resetMoBranchTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setParamName,
	setSiteId,
	setNodeId,
	setDelta,
	resetMoBranchTable,
	setConfigId,
} = moBranch.actions;

export default moBranch.reducer;
